<template>
    <div class="series-wrapper">
        <Tabs :animated="false" size="small" :value="key" @on-click="change">
            <TabPane v-for="(serie, index) in valueArr" :label="`系列${index+1}`" :key="index">
                <span>颜色：</span>
                <ColorPicker :value="serie" transfer @on-change="(value)=>{changeColor(index,value)}"></ColorPicker>
            </TabPane>
        </Tabs>
    </div>
</template>

<script>
export default {
    name: 'seriesTab',
    props: {
        value: {
            type: Array,
            default: ['#2D8CF0', '#00D2B3', '#FBA900', '#F27036', '#B52851', '#2D338A', '#AC3FC0', '#663AB7', '#4356CD', '#109D58', '#7BB342', '#BFC521']
        }
    },
    data() {
        return {
            key: 0,
            valueArr: this.value.concat([])
        }
    },
    methods: {
        changeColor(index,value){
            this.$set(this.valueArr,index,value)
            this.$emit('input', this.valueArr);
            this.$emit('save');
        },
        change(key) {
            this.key = key;
        }
    }
}
</script>
<style lang="less">
.series-wrapper {
    width: 186px;
    .ivu-tabs {
        color: #fff;
    }
    .ivu-tabs-nav-prev,.ivu-tabs-nav-next{
        line-height: 20px;
    }
    .ivu-tabs-mini .ivu-tabs-tab {
        padding: 0 10px 8px 10px;
    }
}
</style>